import React, { useEffect } from 'react'
import HeaderMenuLoggedOut from './HeaderMenuLoggedOut'
import HeaderMenuLoggedIn from './HeaderMenuLoggedIn'
import AhoyTracker from 'shared/ahoy_tracker'

export default function HeaderMenu ({ user, locale, dana }) {

  useEffect(() => {
    const elUserToggleMenu = document.querySelector('.header-login__options');
    const menuHeader = document.querySelector('.header-login__menu');
    const buttonHeaderMenu = document.querySelector(".header-login__more");

    if (buttonHeaderMenu) {
      buttonHeaderMenu.addEventListener('click', () => {
        elUserToggleMenu.classList.toggle('menu-open')
        
        if(elUserToggleMenu.classList.contains('menu-open')){
          sendAhoyImpressionTracker();
        }
      })

      document.addEventListener('click', e => {
        if (elUserToggleMenu.contains(e.target)) {
          return
        }
        
        if (!menuHeader.contains(e.target)) {
          elUserToggleMenu.classList.remove('menu-open')
        }
      })
    }
  }, [])

  const sendAhoyImpressionTracker = () => {
    const element = document.querySelector(".header-login__menu.js-header-menu");

    if (element != null) {
      let ahoy = new AhoyTracker(element);
      ahoy.sendEventImpression();
    }
  }

  if (user.username) {
    return <HeaderMenuLoggedIn locale={locale} user={user} dana={dana}/>
  }

  return (
    <HeaderMenuLoggedOut locale={locale}/>
  )

}
